// @flow
import * as React from 'react';
import { Flex, mediaQueries } from '@locus.sh/neo';
import { canShowPaymentInfo } from 'components/PaymentInfo';
import {
    canShowTripHeader,
    TRIP_HEADER_HEIGHT,
} from 'sections/header/TripHeader';
import { canShowUrlCard, URL_CARD_HEIGHT } from 'sections/header/URLCard';
import { canShowBanner } from 'components/Banner';
import { useBannerContext } from 'sections/state/banner';

const bottomOffset = 184;
const getPaneStyle = function ({
    isShowingPaymentDetails,
    isHeaderShown,
    hasUrlChecklist,
    isBannerShown,
    bannerHeight,
    useFixedBottomPane,
}) {
    let height = 10;
    if (isHeaderShown) height += TRIP_HEADER_HEIGHT;
    if (hasUrlChecklist) height += URL_CARD_HEIGHT;
    if (isBannerShown) height += bannerHeight;

    const mobilePeekStyle = {
        position: 'relative',
        background: '#e5e5e5',
        transform: `translate3d(0, calc(100% - ${bottomOffset}px), 0)`,
        transition: '0.3s ease all',
        zIndex: '14',
        height: `calc(100% - ${height}px)`,
        flexShrink: 0,
    };

    const mobileFixedBottomStyle = {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: 'auto',
        transform: 'none',
        transition: '0.3s ease all',
        zIndex: '14',
        background: '#e5e5e5',
        flexShrink: 0,
    };

    return {
        ...(useFixedBottomPane ? mobileFixedBottomStyle : mobilePeekStyle),
        [mediaQueries.md]: {
            overflow: 'overlay',
            height: 'initial',
            position: 'relative',
            transform: 'none',
            bottom: 'auto',
            left: 'auto',
            right: 'auto',
            width: '100%',
            paddingTop: isShowingPaymentDetails ? '40px' : 0,
            zIndex: 11,
            flex: 1,
            borderRadius: '0',
            boxShadow: 'none',
        },
    };
};

const Pane = (props) => {
    const { tripInfo } = props;
    const { children } = props;
    const hasUrlChecklist = canShowUrlCard(tripInfo);
    const scrollablePaneRef = React.useRef();
    const isShowingPaymentDetails = canShowPaymentInfo(tripInfo);
    const isBannerShownOnTop = canShowBanner(tripInfo, 'belowLogo');
    const isHeaderShown = canShowTripHeader(tripInfo);
    const { bannerHeight } = useBannerContext();
    const enablePanelDragging = tripInfo?.settings?.enablePanelDragging;
    const useFixedBottomPane = !enablePanelDragging;

    return (
        <Flex
            flexDirection="column"
            width="100%"
            boxShadow="active"
            sx={(theme) =>
                getPaneStyle({
                    theme,
                    isHeaderShown,
                    hasUrlChecklist,
                    isShowingPaymentDetails,
                    isBannerShown: isBannerShownOnTop,
                    bannerHeight,
                    useFixedBottomPane,
                })
            }
            ref={scrollablePaneRef}
        >
            {children}
        </Flex>
    );
};

export { Pane };
export default Pane;
